// extracted by mini-css-extract-plugin
module.exports = {"social-share-buttons":"_1rbnn","socialShareButtons":"_1rbnn","social-share-group":"_1IAaU","socialShareGroup":"_1IAaU","social-share-button":"_1kBp6","socialShareButton":"_1kBp6"};